var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.062,
    height: 16.009,
    viewBox: "0 0 16.062 16.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "euro-2",
    transform: "translate(-156.145 -1.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_339",
    "data-name": "Trac\\xE9 339",
    d: "M158.42,7.533a7.9,7.9,0,0,1,13.432-2.9.79.79,0,1,1-1.178,1.054A6.323,6.323,0,0,0,160.1,7.533h3.26a.79.79,0,1,1,0,1.581h-3.671a6.4,6.4,0,0,0,0,1.581h3.671a.79.79,0,1,1,0,1.581H160.1a6.323,6.323,0,0,0,10.575,1.844.79.79,0,1,1,1.178,1.054,7.9,7.9,0,0,1-13.432-2.9h-1.385a.79.79,0,1,1,0-1.581H158.1c-.025-.26-.039-.524-.039-.79s.013-.53.039-.79h-1.062a.79.79,0,1,1,0-1.581Z",
    transform: "translate(0 0)",
    stroke: "#000",
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.34e419a8311fbce97eb7209bc63c27ce.svg";
export { ForwardRef as ReactComponent };